(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/views/roundlist.js') >= 0) return;  svs.modules.push('/modules/game-results/views/roundlist.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.game_results=_svs.game_results||{};
_svs.game_results.templates=_svs.game_results.templates||{};
svs.game_results.templates.roundlist = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
Handlebars.partials['svs-game_results-roundlist'] = svs.game_results.templates.roundlist;
})(svs, Handlebars);


 })(window);